<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-row align-h="between" align-v="center">
              <h4 class="card-tittle">Gastos Reembolsables</h4>
              <export-button :data="dataExport" fileName="Gastos_Reembolsables" title="'Exportar todo" />
            </b-row>
                <filters
                    v-model="filtersValue"
                    @change="getGastos"
                    patentView="getPatentsTAGByRut"
                />

            <b-table
              :items="tableData"
              :fields="fields"
              :current-page="currentPage"
              :busy="isBusy"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              responsive 
              show-empty
            >
              <!-- Inicio Spinner en estado "ocupado" de la tabla -->
              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <!-- Fin Spinner en estado "ocupado" de la tabla -->

              <template #cell(ordReemFecha)="row">
                {{ getDate(row.value) }}
              </template>
              <template #cell(ordReemFecDig)="row">
                {{ getDate(row.value) }}
              </template>
              <template #cell(ordReemFecDoc)="row">
                {{ getDate(row.value) }}
              </template>
              <template #cell(ordReemMonto)="row">
                ${{ getCurrency(row.value) }}
              </template>
              <template #cell(monto)="row">
                ${{ getCurrency(row.value) }}
              </template>
              <template #empty="">
                  <h5 style="text-align: center">
                  {{ $t("request.table.empty") }}
                  </h5>
              </template>
              <template #cell(ordReemOtNro)="row">
                <a class="links" @click="navigateToDetail(row)">
                  {{ row.value }}
                </a>
              </template>
              <template #cell(doc)="row">
                <b-button variant="danger" size="sm" @click="verDocumentos(row.item.item)">
                  <i class="bx bx-download font-size-18 align-middle"/>
                </b-button>
              </template>
            </b-table>

            <!-- Inicio Paginación -->
            <div class="col">
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    class="portal"
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="totRegistros"
                  ></b-pagination>
                </ul>
              </div>
            </div>
            <!-- Fin Paginación -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import ExportButton from "@/components/export-button";
import tableConfig from "./tableConfig";
import { getDateWithFormat, formatCurrency, thousandSeparator } from "@/utils";
import axios from "@/axios";
import DPConfig from "../../../components/dataPickerConf";
import moment from 'moment';
import Filter from "../../../components/filters/Filter";

export default {
  data() {
    return {
      sortBy: 'ordReemOtNro',
      sortDesc: true,
      lang: {
        formatLocale: DPConfig.formatLocale
      },
      EstadodePago: "",
      fields: tableConfig.fields,
      tableData: [],
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      totRegistros: 1,
      isBusy: false,
      dataExport: [],
      daterange: [new Date("2000-01-01"), new Date()],
      filtersValue: {
        period: "",
        patent: "",
      },
    };
  },
  components: {
    Layout,
    "export-button": ExportButton,
    "filters": Filter
  },
  beforeMount(){
    this.getGastos();
  },
  methods: {
    getDate(date) {
      return getDateWithFormat(date);
    },
    getCurrency(inport) {
      return formatCurrency(inport);
    },
    getNumberWithSeparators(number) {
      return thousandSeparator(number);
    },
    getGastos() {
      let path = "";
      this.EstadodePago = this.filtersValue.payState;
      this.isBusy = true;
      let fechaDesde = this.filtersValue.period[0] ? moment(this.filtersValue.period[0]).format('YYYY-MM-DD') : moment(new Date("2000-01-01")).format('YYYY-MM-DD');
      let fechaHasta = this.filtersValue.period[1] ? moment(this.filtersValue.period[1]).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD');
      this.EstadodePago
      ? path = `/GastosReembolsablesLop?Pagina=${this.currentPage}&Registros=${this.perPage}&EstadodePago=${this.EstadodePago}` +
          `&pagina=${this.currentPage}`+
          `&registros=${this.perPage}`+
          `&fechaDesde=${fechaDesde}`+
          `&fechaHasta=${fechaHasta}`+
          `&Patente=${this.filtersValue['patent']}`+
          `&Autorizado=true`+
          `&Rut=${this.$store.state.rutEmpresa.cuentaSeleccionada.value}`
      : path = `/GastosReembolsablesLop?` +
          `&pagina=${this.currentPage}`+
          `&registros=${this.perPage}`+
          `&fechaDesde=${fechaDesde}`+
          `&fechaHasta=${fechaHasta}`+
          `&Patente=${this.filtersValue['patent']}`+
          `&Autorizado=true`+
          `&Rut=${this.$store.state.rutEmpresa.cuentaSeleccionada.value}`
      this.getData(path);
    },
    getData(path){
      this.isBusy = true;
      axios
        .get(path)
        .then((gastos) => {
          this.tableData = gastos.data.datos;
          this.totRegistros = gastos.data.totalRegistros;
          this.isBusy = false;
          this.getToExport();
        })
        .catch((error) => {
          if (error.response) {
            this.$bvToast.toast(this.$t('NoData.error.message').toString(), {
                title: this.$t('NoData.error.title').toString(),
                variant: 'danger',
                solid: true
            });
            this.isBusy = false;
          }
      });
      this.isBusy = false;
    },
    navigateToDetail(row) {
      this.$store.dispatch("hideValue/updateFilter", this.filtersValue);
      this.$store.dispatch("hideValue/updateGastos", row);
      this.$router.push({ name: "gastosReembolsablesDetail" });
    },
    getToExport() {
      let path = "";
      this.EstadodePago = this.filtersValue.payState;
      let fechaDesde = this.filtersValue.period[0] ? moment(this.filtersValue.period[0]).format('YYYY-MM-DD') : moment(new Date("2000-01-01")).format('YYYY-MM-DD');
      let fechaHasta = this.filtersValue.period[1] ? moment(this.filtersValue.period[1]).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD');
      this.EstadodePago
          ? path = `/GastosReembolsablesLop?Pagina=${this.currentPage}&Registros=${this.perPage}&EstadodePago=${this.EstadodePago}` +
              `&pagina=1`+
              `&registros=${this.totRegistros}`+
              `&fechaDesde=${fechaDesde}`+
              `&fechaHasta=${fechaHasta}`+
              `&Patente=${this.filtersValue['patent']}`+
              `&Autorizado=true`+
              `&Rut=${this.$store.state.rutEmpresa.cuentaSeleccionada.value}`
          : path = `/GastosReembolsablesLop?` +
              `&pagina=1`+
              `&registros=${this.totRegistros}`+
              `&fechaDesde=${fechaDesde}`+
              `&fechaHasta=${fechaHasta}`+
              `&Patente=${this.filtersValue['patent']}`+
              `&Autorizado=true`+
              `&Rut=${this.$store.state.rutEmpresa.cuentaSeleccionada.value}`
      axios
          .get(path)
          .then((detalles) => {
            this.dataExport = detalles.data.datos;
          })
    },
  },
  watch: {
    currentPage() {
      this.getGastos();
    },
  },
};
</script>

<style scoped>

</style>
